<template>
  <div :class="['layout-group', 'grid-flex-wrap', css, layoutReady ? 'ready' : '']">
    <div v-for="(layout, i) in children" 
      :class="[
        'layout-group--partial',
        !elementReady[i] ? 'loading' : '',
        layout.css,
        `el-size--${elementSizes[i]}`
      ]"
      :key="(layout.css || layout.id) + i"
      :ref="`layout-partial-${i}`"
    >
      <i
        key="toggler"
        v-if="size === 'small' && isMobileMode(layout)"
        @click="mobileOpen = !mobileOpen"
        :class="[
          'toggler',
          'fas',
          !mobileOpen ? 'fa-sliders-h' : 'fa-chevron-left'
        ]"
      ></i>
      <preloader v-if="!elementReady[i]"></preloader>
      <transition-group :css="false"
        @before-enter="beforeEnter"
        @enter="enter"
        @leave="leave"
        appear
        tag="div"
        :class="[
          'comp-wrap',
          size === 'small' && isMobileMode(layout) ? 'mobile-mode' : '',
          !mobileOpen ? 'closed' : 'open'
        ]"
      >
        <template v-if="elementReady[i]">                    
          <template v-if="layout.type === 'publication-table' || !layout.children.length">
            <component
              :is="layout.type"
              :key="layout.type"
              :resize-trig="resizeTrig"
              :class="layout.type === 'h1' ? 'heading' : ''"
              v-bind="layout"
              :size="elementSizes[i]"
              is-partial
            >
              <span
                key="h1"
                v-if="layout.type === 'h1'"
                v-text="layout.title"
              ></span>
            </component>
          </template>
          <template v-else>              
            <component
              v-for="(comp, index) in layout.children"
              :key="comp.type + index"
              :is="comp.type"
              :resize-trig="resizeTrig"
              :class="[comp.type === 'h1' ? 'heading' : '']"
              v-bind="comp"
              :size="elementSizes[i]"
              is-partial
            >
            </component>
          </template>
        </template>
      </transition-group>
    </div>
  </div>
</template>
<script>
export default {
  name: "layout-group",
  props: {
    children: {
      type: Array,
      required: true
    },
    resizeTrig: {
      type: Number,
      default: -1
    },
    size: {
      type: String,
      default: "large"
    },
    type: {
      type: String,
      default: null
    },
    css: {
      type: String,
      default: ""
    },
    commonData: [Object, Array]
  },
  watch: {
    resizeTrig() {
      let vm = this;
      // console.log("resize triggered inside layout group >> ");
      if (!_.isEmpty(this.$refs)) {
        let refs = _.toArray(this.$refs);
        this.elementSizes.length = refs.length;
        this.elementReady.length = refs.length;
        _.flattenDeep(refs).forEach((el, index) => {
          let width = el.offsetWidth;
          if (width > 1200) {
            vm.$set(vm.elementSizes, index, "large");
          } else if (width > 767) {
            vm.$set(vm.elementSizes, index, "medium");
          } else {
            vm.$set(vm.elementSizes, index, "small");
          }
          vm.$set(vm.elementReady, index, true);
        });
      }
    }
  },
  data() {
    return {
      elementSizes: [],
      elementReady: [],
      layoutReady: false,
      mobileOpen: false
    };
  },
  computed: {
    elWidth() {
      return this.$el.offsetWidth;
    }
    // filteredChildren() {
    //   return _.filter(this.children, c=> c.children.length)
    // }
    // layoutReady() {
    //   let ready = this.elementReady;
    //   return _.reject(ready).length<1
    // }
  },
  methods: {
    isMobileMode(layout) {
      return layout && layout.css && layout.css.indexOf("mobile") > -1;
    },
    withChildren(children) {
      /* 
          Give me either a list with children
          Or not a list...
      */
      return _.filter(children, c => !/list/.test(c.type) || c.children.length);
    },
    beforeEnter: function(el) {
      el.style.opacity = 0;
      el.style.transform = "translateY(20%)";
    },
    enter: function(el, done) {
      let vm = this,
        lapse = 120,
        delay = el.dataset.index * lapse;
      setTimeout(function() {
        el.animate(
          {
            opacity: [0, 1],
            transform: ["translateY(20%)", "translateY(0)"],
            easing: "cubic-bezier(0.175, 0.885, 0.32, 1.275)"
          },
          { duration: 600, fill: "forwards" }
        ).onfinish = function() {
          vm.layoutReady = true;
          done();
        };
      }, delay);
    },
    leave: function(el, done) {
      el.style.opacity = 0;
      el.style.transform = "translateY(120%)";
      done();
    }
  }
};
</script>
<style lang="stylus">
.layout-group
  position relative
  overflow hidden
  &.ready
    overflow initial
  &.bar
    _flex(column,nowrap,flex-start,flex-start)
    pad('l', top)
    pad('l', bottom)
    background #fff
    +above(500px)
      height 14vh
      _flex(row,wrap,center,space-between)
  .content-block--text h3
    font-family "Inter", "NimbusSanNov W05 Regular" !important
    letter-spacing -0.5px
  &--partial
    max-width 100%
    &:first-child
      z-index 9
    &.loading
      min-height calc(100vh - 176px)
    &.el-size--small.mobile-overlay
      .toggler
        cursor pointer
        position absolute
        left 8.5vw
        top 0
        transform translate(0, 100%)
        z-index 12
        +below(816px)
          left 5vw
          +portrait()
            left 8.5vw
      .comp-wrap
        &.mobile-mode
          position absolute 0 0 0 0
          background #fff
          width 100%
          height 100%
          min-height 90vh
          z-index 11
          transition transform 0.4s ease-out-cubic
          pad('3xl')
          box-shadow 10px 0 5px rgba(0,0,0,0.2)
          &.closed
            transform translateX(-110%)
          &.open
            transform translateX(0)
  +above(815px)
    _flex(row,wrap,stretch,space-between)
    &--partial
      background #fff
      position relative
      flex 1
      &.in-scroll
        max-height 100vh
        overflow-y auto
  +above(1024px)
    &--partial
      &.left
        flex 0 0 68%
      &.right
        flex 0 0 32%
</style>
